<template>
  <div class="step-loader">
    <div class="inner">
      <span class="spinner-loader"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loader'
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.step-loader{
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($white, 0.9);
  z-index: 10;

  .inner{
    width: auto;

    .spinner-loader {
      display: inline-block;
      width: 60px;
      height: 60px;
    }

    .spinner-loader:after {
      content: " ";
      display: block;
      width: 32px;
      height: 32px;
      margin: 8px;
      border-radius: 50%;
      border: 6px solid $primary;
      border-color: $primary rgba($primary, 0.2) rgba($primary, 0.2) rgba($primary, 0.2);
      animation: spin-loader 1.2s linear infinite;
    }

    @keyframes spin-loader {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
